var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.19113C0 3.9942 0.979305 3.01489 2.17623 3.01489H18.498C18.7866 3.01489 19.0633 3.12953 19.2674 3.33359C19.4715 3.53766 19.5861 3.81442 19.5861 4.10301V5.19113H2.17623V6.27924H20.6742C20.9628 6.27924 21.2396 6.39388 21.4436 6.59794C21.6477 6.80201 21.7623 7.07877 21.7623 7.36736V18.2485C21.7623 18.8257 21.533 19.3792 21.1249 19.7874C20.7168 20.1955 20.1633 20.4248 19.5861 20.4248H2.17623C1.59906 20.4248 1.04553 20.1955 0.637404 19.7874C0.229281 19.3792 0 18.8257 0 18.2485V5.19113ZM17.9539 14.9842C18.3868 14.9842 18.802 14.8122 19.108 14.5061C19.4141 14.2 19.5861 13.7849 19.5861 13.352C19.5861 12.9191 19.4141 12.504 19.108 12.1979C18.802 11.8918 18.3868 11.7198 17.9539 11.7198C17.521 11.7198 17.1059 11.8918 16.7998 12.1979C16.4937 12.504 16.3217 12.9191 16.3217 13.352C16.3217 13.7849 16.4937 14.2 16.7998 14.5061C17.1059 14.8122 17.521 14.9842 17.9539 14.9842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_1170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7623,
    height: 21.7623,
    fill: "white",
    transform: "translate(0 0.838623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWallet);
export default __webpack_public_path__ + "static/media/account-wallet.a2db5892ec304fc9fe9b5e6c72b65155.svg";
export { ForwardRef as ReactComponent };